export default "__VITE_ASSET__BGTqhK5X__"